import useCurrentUserProfile from "hooks/useCurrentUserProfile";
import { useUpdateUserProfileMutation } from "./useUpdateUserProfileMutation";
import { useAuth0 } from "@auth0/auth0-react";

export const useTurnOffVtourManualOnStartMutation = () => {
  const { user } = useAuth0();
  const { mutate: updateUserProfile } = useUpdateUserProfileMutation(user?.sub || "");

  const turnOffVtourManualOnStart = async () => {
    await updateUserProfile({
      metadata: {
        showVirtualTourManual: false,
      }
    })
  }

  return {
    turnOffVtourManualOnStart,
  }
}